module.exports = __webpack_public_path__ + "static/img/icon-card.ef32677.png";


//////////////////
// WEBPACK FOOTER
// ./static/theme/normal/img/icon-card.png
// module id = oDWg
// module chunks = 15